import { render, staticRenderFns } from "./ReviewsSendController.vue?vue&type=template&id=042e6118&"
import script from "./ReviewsSendController.vue?vue&type=script&lang=ts&"
export * from "./ReviewsSendController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports